import React from 'react';
import { Flex, Text } from 'rebass';
import styled from 'styled-components';
import colors from 'theme/colors';

const StyledText = styled(Text)<any>`
  border: ${props => (props.active ? 'none' : `1px solid ${colors.lightGreen}`)};
  position: relative;

  &::before {
    content: '';
    display: block;
    position: absolute;
    left: ${props => (props.active ? '-1px' : '0px')};
    top: -1px;
    width: 0;
    height: 0;
    border-top: 23px solid transparent;
    border-left: 10px solid ${props => (props.active ? colors.white : colors.lightGreen)};
    border-bottom: 23px solid transparent;
    z-index: 1;
  }

  &::after {
    content: '';
    display: block;
    position: absolute;
    right: -10px;
    top: -1px;
    width: 0;
    height: 0;
    border-top: 23px solid transparent;
    border-left: 10px solid ${props => (props.active ? colors.lightGreen : colors.white)};
    border-bottom: 23px solid transparent;
    z-index: 2;
  }
`;

const UnderStyledBlock = styled(Text)<any>`
  width: 100%;
  height: 100%;
  position: absolute;
  top: 0;
  &::before {
    content: '';
    display: block;
    position: absolute;
    left: ${props => (props.active ? '-3px' : '-1px')};
    top: -1px;
    width: 0;
    height: 0;
    border-top: 23px solid transparent;
    border-left: 10px solid ${colors.white};
    border-bottom: 23px solid transparent;
    z-index: 1;
  }

  &::after {
    content: '';
    display: block;
    position: absolute;
    right: -11px;
    top: -1px;
    width: 0;
    height: 0;
    border-top: 23px solid transparent;
    border-left: 10px solid ${props => (props.active ? colors.white : colors.lightGreen)};
    border-bottom: 23px solid transparent;
    z-index: 2;
  }
`;

const FormStepLabel: React.FC<any> = ({ children, active }): JSX.Element => (
  <Flex>
    <StyledText
      width="295px"
      bg={active ? 'lightGreen' : 'white'}
      color={active ? 'white' : 'primary'}
      fontSize="20px"
      fontWeight={6}
      textAlign="center"
      py={1}
      active={active}
    >
      <UnderStyledBlock active={active} />
      {children}
    </StyledText>
  </Flex>
);

export default FormStepLabel;
